import Currency, { type CurrencyStatus } from "./Currency";
import { cn } from "@/lib/utils";

interface MetricCardProps {
  label: string;
  value: number | string;
  status?: CurrencyStatus;
  valueClassName?: string;
}

export default function MetricCard({
  label,
  value,
  status = "default",
  valueClassName,
}: MetricCardProps) {
  return (
    <div>
      <div className="text-xs uppercase tracking-widest text-primary-600 dark:text-primary-400 mb-2">
        {label}
      </div>
      <div
        className={cn(
          "text-2xl font-light",
          status === "default" &&
            (valueClassName || "text-primary-950 dark:text-white")
        )}
      >
        <Currency value={value} status={status} />
      </div>
    </div>
  );
}
